import { render } from "./RibbonIcon.vue?vue&type=template&id=f56440d4&scoped=true"
import script from "./RibbonIcon.vue?vue&type=script&lang=js"
export * from "./RibbonIcon.vue?vue&type=script&lang=js"

import "./RibbonIcon.vue?vue&type=style&index=0&id=f56440d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56440d4"]])

export default __exports__